<template>
  <div id="articlefoot">
    <div class="main">
      <div class="cc">
        <div class="ewm">
          <div class="top">
            <div class="left">
              <img src="@/assets/img/articlefoot_img_bg_gzh.png" alt="">
            </div>
            <div class="right">
              <h5>育德园师微信公众号</h5>
              <p>
                每日推送精彩考试报考<br>
                长按二维码识别<br>
                微信搜索“育德园师课堂”
              </p>
            </div>
          </div>
          <div class="bottom">
            <div class="left">
              <img src="@/assets/img/articlefoot_img_bg_qq.png" alt="">
            </div>
            <div class="right">
              <h5>加入QQ群一起来考证！</h5>
              <p>QQ群号：723236610</p>
              <a href="https://jq.qq.com/?_wv=1027&k=5a5dCcU">点击进入</a>
            </div>
          </div>
        </div>
      </div>
      <div class="title">
        <img src="@/assets/icon/articlefoot_icon_logo.png" alt="">
        <div>
          <h4>育德园师客户端</h4>
          <p>报考，试题，视频一手掌握</p>
        </div>
      </div>
      <router-link :to="{name: 'AppDown'}" class="setup">一键安装做题</router-link>
    </div>
    <nav>
      <div class="main">
        <a @click="login">学习登录</a>
        <a href="tel:4006255668">联系我们</a>
      </div>
    </nav>
    <div class="copyright">
      <p>
        COPYRIGHT © 2006-2024 教师资格证考试版权 <br>
        所有：育德园师
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'articleFoot',
  props: [
    'pageName'
  ],
  methods: {
    gotoIndex () {
      this.$router.push({name: 'Index'})
    },
    login () {
      if (this.pageName === 'ArticleDetail') {
        this.$emit('listenLogin', true)
        return false
      }
      this.$router.push({name: 'PwdLogin', query: {backto: this.pageName ? this.pageName : 'Index'}})
    }
  }
}
</script>

<style scoped lang="stylus">
#articlefoot
  > .main
    width: 7.5rem
    height: 9.68rem
    background: url(../../../assets/img/articlefoot_img_bg1.png) no-repeat center bottom #fff
    -webkit-background-size: 7.5rem 4.6rem
    border-top: .2rem solid #f9f9f9
    background-size: 7.5rem 4.6rem
    overflow: hidden
    padding: .4rem 0 0
    margin-top: .2rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    .cc
      width: 7.1rem
      height: 5.25rem
      background-color: #f5faff
      overflow: hidden
      margin: 0 auto
      -webkit-border-radius: .3rem
      -moz-border-radius: .3rem
      border-radius: .3rem
      .ewm
        width: 6.7rem
        height: 4.84rem
        border: .02rem solid #c9e1fe
        background: url(../../../assets/img/articlefoot_img_bg_person.png) no-repeat right bottom
        -webkit-background-size: 1.8rem 1.52rem
        background-size: 1.8rem 1.52rem
        margin: .2rem auto
        -webkit-border-radius: .3rem
        -moz-border-radius: .3rem
        border-radius: .3rem
        .top
          display: flex
          justify-content: left
          width: 6.3rem
          height: 2.42rem
          border-bottom: .02rem dashed #c9e1fe
          padding: .3rem .24rem
          margin: 0 auto
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          .left
            width: 1.75rem
            height: 1.75rem
            border: .02rem solid #75b2fc
            background-color: #fff
            overflow: hidden
            margin-right: .3rem
            -webkit-border-radius: .1rem
            -moz-border-radius: .1rem
            border-radius: .1rem
            img
              width: 100%
              height: 100%
          .right
            h5
              margin-top: .1rem
              font-size: .3rem
              color: #0987fb
              font-weight: 600
            p
              line-height: .4rem
              margin-top: .1rem
              font-size: .28rem
              color: #999
        .bottom
          display: flex
          justify-content: left
          width: 6.3rem
          height: 2.42rem
          padding: .3rem .24rem
          margin: 0 auto
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          .left
            width: 1.75rem
            height: 1.75rem
            border: .02rem solid #75b2fc
            background-color: #fff
            overflow: hidden
            padding: .08rem
            margin-right: .3rem
            -webkit-border-radius: .1rem
            -moz-border-radius: .1rem
            border-radius: .1rem
            -webkit-box-sizing: border-box
            -moz-box-sizing: border-box
            box-sizing: border-box
            img
              width: 100%
              height: 100%
          .right
            h5
              margin-top: .1rem
              font-size: .3rem
              color: #0987fb
              font-weight: 600
            p
              line-height: .4rem
              margin-top: .1rem
              font-size: .28rem
              color: #999
            a
              display: block
              width: 1.56rem
              height: .5rem
              line-height: .5rem
              border: .02rem solid #a4a4a5
              margin-top: .2rem
              font-size: .28rem
              color: #999
              text-align: center
              -webkit-border-radius: .5rem
              -moz-border-radius: .5rem
              border-radius: .5rem
    .title
      display: flex
      width: 5.2rem
      height: 1.5rem
      margin: .3rem auto 0
      img
        width: 1.49rem
        height: 1.49rem
      h4
        margin: .25rem .2rem .1rem
        font-size: .32rem
        color: #333
        font-weight: 700
      p
        margin: .15rem 0 0 .2rem
        font-size: .2812rem
        color: #666
    a.setup
      display: block
      width: 5.9rem
      height: .9rem
      line-height: .9rem
      border: .02rem solid #dedede
      background-color: #fff
      margin: .4rem auto
      font-size: .32rem
      color: #333
      font-weight: 700
      text-align: center
      -webkit-border-radius: .5rem
      -moz-border-radius: .5rem
      border-radius: .5rem
  nav
    position: relative
    left: -.2rem
    width: 7.5rem
    background-color: #fff
    margin-top: .1rem
    .main
      display: flex
      justify-content: space-around
      align-items: center
      width: 4rem
      height: 1rem
      margin: 0 auto
      a
        display: block
        width: 1.36rem
        height: .52rem
        line-height: .52rem
        border: .02rem solid #e6e6e6
        background-color: #fff
        font-size: .24rem
        color: #666
        text-align: center
  .copyright
    position: relative
    left: -.2rem
    width: 7.5rem
    height: 1rem
    overflow: hidden
    background-color: #fff
    p
      font-size: .28rem
      color: #666
      text-align: center
</style>



// WEBPACK FOOTER //
// src/components/share/footer/articleFoot.vue